import styled, { css } from 'styled-components';
import { color, font, space, query } from '@design/templateFns';

export const Headline = styled.h2`
  ${font('headline-md')};
  text-align: center;
  @media screen and (${query.below('tablet')}) {
    ${font('headline-xs')};
  }
`;

export const NeighborhoodWrapper = styled.div<{ $amount: number }>`
  display: grid;
  grid-gap: ${space('lg')};
  grid-template-columns: 1fr 1fr;

  @media screen and (${query.atLeast('desktop')}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: ${space('xl')};
  }

  //add different css based on amount of neighborhoods
  ${({ $amount }) =>
    $amount === 1 &&
    css`
      @media screen and (${query.below('desktop')}) {
        // below desktop full width
        > div {
          grid-column: span 2;
        }
      }

      @media screen and (${query.atLeast('desktop')}) {
        // above the desktop it's also full width
        > div {
          grid-column: span 3;
        }
      }
    `}

  ${({ $amount }) =>
    $amount === 2 &&
    css`
      @media screen and (${query.below('desktop')}) {
        // below desktop they are both span of 2
        > div {
          grid-column: span 2;
        }
      }

      @media screen and (${query.atLeast('desktop')}) {
        // above the desktop only the first one is span of 2/3
        > div:nth-child(1) {
          grid-column: span 2;

          > div {
            // slight tweak to accommadate the grid gap
            padding-top: calc(50% - 10px);
          }
        }
        > div:nth-child(2) {
          > div {
            // slight tweak to accommadate the grid gap
            padding-top: 100%;
          }
        }
      }
    `}

  ${({ $amount }) =>
    $amount === 3 &&
    css`
      @media screen and (${query.below('desktop')}) {
        // below desktop, the first element is full width
        > div:nth-child(1) {
          grid-column: span 2;
        }
      }
      @media screen and (${query.atLeast('desktop')}) {
        // above the desktop, first element is full and second element is 2/3
        > div:nth-child(1) {
          grid-column: span 3;
        }
        > div:nth-child(2) {
          grid-column: span 2;

          > div {
            // slight tweak to accommadate the grid gap
            padding-top: calc(50% - 10px);
          }
        }
        > div:nth-child(3) {
          > div {
            // slight tweak to accommadate the grid gap
            padding-top: 100%;
          }
        }
      }
    `}

  ${({ $amount }) =>
    $amount === 4 &&
    css`
      @media screen and (${query.below('desktop')}) {
        // below desktop, the first and 4th is full width
        > div:nth-child(1),
        > div:nth-child(4) {
          grid-column: span 2;
        }
      }
      @media screen and (${query.atLeast('desktop')}) {
        // above the desktop, first element is full
        > div:nth-child(1) {
          grid-column: span 3;
        }
      }
    `}

  ${({ $amount }) =>
    $amount === 5 &&
    css`
      > div:nth-child(1) {
        // for all widths, the first element is span of 2 (2/3 on desktop, 2/2 on mobile)
        grid-column: span 2;

        @media screen and (${query.atLeast('desktop')}) {
          > div {
            // slight tweak to accommadate the grid gap
            padding-top: calc(50% - 10px);
          }
        }
      }
      > div:nth-child(2) {
        @media screen and (${query.atLeast('desktop')}) {
          > div {
            padding-top: 100%;
          }
        }
      }
    `}
`;

export const ButtonPadding = styled.div`
  text-align: center;
  padding-top: ${space('x7')};

  @media screen and (${query.atLeast('desktop')}) {
    padding-top: ${space('x12')};
  }
`;
